import type { JSX } from "preact";
import { useTranslations } from "../../hooks/useTranslations";

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
};

export function SearchInput({
  value,
  onChange,
  placeholder,
  className = "",
  disabled = false,
}: SearchInputProps) {
  const t = useTranslations();
  const inputPlaceholder = placeholder ?? t.search;
  const handleInput = (e: JSX.TargetedEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  return (
    <div className={`festapp-search ${className}`}>
      <svg
        className="festapp-search-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <input
        type="text"
        className="festapp-search-input"
        style={{ paddingLeft: "48px", paddingRight: "44px", marginBottom: 0 }}
        value={value}
        onInput={handleInput}
        placeholder={inputPlaceholder}
        disabled={disabled}
      />
      {value && (
        <button
          type="button"
          className="festapp-search-clear"
          onClick={() => onChange("")}
          aria-label={t.clearSearch}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
